import React, { PropsWithChildren, useContext } from "react";
import "react-pdf/dist/Page/TextLayer.css";
import { DocumentPDF } from "./DocumentPDF";
import { PageWidthContext } from "../dealsPageLayout/DealsPageLayout";
import { Box } from "@mui/material";

type ShowDocumentProps = PropsWithChildren<{
  dealDocumentContents: Blob;
  onLoaded?: () => void;
}>;

const DealDocumentPDF = ({
  dealDocumentContents,
  children,
  onLoaded,
}: ShowDocumentProps) => {
  const pageWidth = useContext(PageWidthContext);

  const container: React.CSSProperties = {
    height: "90vh",
    overflowX: "hidden",
    overflowY: "auto",
    width: pageWidth + 2, //maintain the page border around the document and room for the scrollbar if needed
  };

  return (
    <div style={container} data-testid="document-container">
      <DocumentPDF
        width={pageWidth}
        contents={dealDocumentContents}
        onLoaded={onLoaded}
      />
      {children}
      {/* this is to add a bottom margin at the end of the document */}
      <Box height="100px" />
    </div>
  );
};

export default DealDocumentPDF;
